module.exports = __webpack_public_path__ + "assets/img/gpt-bg-l.f7abb9d6.png";